export const numberFormatOptions = {
  style: 'currency',
  currency: 'BRL',
};

export const coinName = {
  AUD: 'Dólar australiano',
  BRL: 'Real',
  CAD: 'Dólar canadense',
  EUR: 'Euro',
  GBP: 'Libra Esterlina',
  NZD: 'Dólar neozelandês',
  USD: 'Dólar americano',
  ZAR: 'Rand sul-africano',
};

export const defaultPricing = (price) =>
  price.toLocaleString('pt-BR', numberFormatOptions);

export const convertCentsToInt = (valueInCents = 100, currency = 'BRL') =>
  Number(valueInCents / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency,
  });
